import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';
import 'swiper/css';

const SwiperPagination = Pagination;

export { Swiper, SwiperSlide, SwiperPagination };
